import React from "react";
import { reduxForm } from "redux-form";
import classnames from "classnames"
import { values } from "ramda"

import { validateRecorderForm } from "../recorderValidations";
import { SEARCH_UNIVERSE } from "../constants";
import { DIRECTION, COMMUNICATED_VIA } from "../../common/constants";
import ValidityPeriod from "./ValidityPeriod";
import RecommendationLegs from "./RecommendationLegs";
import ConflictOfInterest from "./ConflictOfInterest";
import ProducedOn from "./ProducedOn";
import DisseminatedOn from "./DisseminatedOn";
import CommunicatedVia2 from "./CommunicatedVia";
import RemoveButton from "./RemoveButton";
import Recipients from "../../contacts/components/Recipients";
import Header from "../../common/components/Header";
import { USER_ENTERED_DATE_TIME_PROP_TYPES } from "../models";
import { instrumentWith } from "../models";
import { submitDissemination } from "../actions/submitDissemination";
import {MAIN_SECTION} from "../../styles";
import Label from "../../common/components/Label";
import ContactGroups from "../../contacts/components/ContactGroups";
import { classNameForValidationErrors } from "../../common/components/componentUtils";
import { saveSelectedSearchUniverse, previouslySelectedSearchUniverse } from "./selectedSearchUniverseStorage";
import { LIGHT_TEXT_COLOR } from "../../common/styles";

const Reasoning = (props) => (
    <div className="pure-control-group">
        <Label htmlFor="reasoning">Reasoning</Label>
        <input id="reasoning"
               type="text"
               className="x-reasoning-input idea-attribute__input"
               style={{width: 306}}
               value={props.value}
               onChange={props.onChange}
               placeholder="(not sent to client)"
               rows="5"/>
    </div>
);
Reasoning.propTypes = {
    value: React.PropTypes.string,
    onChange: React.PropTypes.func
};

const SearchUniverse = (props) => (
    <div style={{display: "inline-block", backgroundColor: "#96BBE6", padding: "0 0.5em", borderRadius: "0 4px 4px 0"}}>
        <select value={props.value}
                onChange={props.onChange}
                className="x-search-universe"
                style={{
                    backgroundColor: "#96BBE6",
                    boxShadow: "none",
                    border: "0",
                    color: "white"
                }}>
            <option value={SEARCH_UNIVERSE.EQUITY}>EQUITY</option>
            <option value={SEARCH_UNIVERSE.FIXED_INCOME}>FIXED INCOME</option>
            <option value={SEARCH_UNIVERSE.FX}>FX</option>
        </select>
    </div>
);
SearchUniverse.propTypes = {
    onChange: React.PropTypes.func,
    value: React.PropTypes.string
};

const Recommendation = (props) => (
    <div style={{marginLeft: 16}} className="x-single-recommendation">
        <div style={{ position: "relative", left: -16, top: 6, zIndex: 1 }}>
            <div style={{
                display: "inline-block",
                backgroundColor: "#4A90E2",
                padding: "8px",
                minWidth: "1em",
                textAlign: "center",
                borderRadius: "4px",
                color: "white",
                position: "relative",
                left: 5,
                top: 2
            }}>{props.index + 1}</div>
            <SearchUniverse value={ props.recommendation.searchUniverse.value }
                            onChange={(event) => {
                                props.onSearchUniverseChange(event.target.value);
                                props.recommendation.searchUniverse.onChange(event);
                            }} />
        </div>
        <div
             style={{
                 position: "relative",
                 borderRadius: "0 4px 4px 0",
                 backgroundColor: "#eee",
                 borderLeft: "4px solid rgb(0, 120, 231)",
                 marginBottom: 10,
                 padding: 10
             }}>
            <RecommendationLegs {...props} />

            <ProducedOn {...props.recommendation.producedOn}
                        className={classNameForValidationErrors(props.recommendation.producedOn)} />

            <ValidityPeriod {...props.recommendation.validityPeriod} />

            <Reasoning {...props.recommendation.reasoning} />

            <ConflictOfInterest {...props}  />

            <RemoveButton style={{
                              borderRadius: "0 3px 3px 0",
                              padding: 5,
                              backgroundColor: "#eee",
                              position: "absolute",
                              right: -20,
                              top: 0,
                              fontWeight: "bold",
                              fontSize: "140%",
                              color: "#bbb",
                              cursor: "pointer"
                          }}
                          className="x-remove-recommendation"
                          onClick={ props.onRemoveButtonClick } />
        </div>
    </div>
);
Recommendation.propTypes = {
    onRemoveButtonClick: React.PropTypes.func,
    onSearchUniverseChange: React.PropTypes.func
};

const recommendationInitialValues = () => {
    return {
        searchUniverse: previouslySelectedSearchUniverse(SEARCH_UNIVERSE.EQUITY),
        producedOn: null,
        legs: [{
            direction: DIRECTION.BUY,
            instrument: instrumentWith()
        }]
    };
};
const Recommendations = (props) => (
    <div style={{float: "left", width: 620, marginRight: 20, padding: 10}}>
        {
            props.fields.recommendations.map((recommendation, index) =>
                <Recommendation key={index}
                                index={index}
                                recommendation={recommendation}
                                onRemoveButtonClick={() => props.fields.recommendations.removeField(index)}
                                onSearchUniverseChange={saveSelectedSearchUniverse}/>
            )
        }

        <button type="button" className="x-add-recommendation pure-button" onClick={(e) => {
            e.preventDefault();
            props.fields.recommendations.addField(recommendationInitialValues())}
        }>Add Another Recommendation</button>
    </div>
);

const ToWhom = (props) => (
    <div className={ classnames("pure-control-group", classNameForValidationErrors(props)) } >
        <Label style={ props.labelStyle }>To whom?</Label>

        <Recipients {...props}
                    contactGroups={ props.contactGroups }
                    style={{
                        display: "inline-block",
                        width: "20em",
                        verticalAlign: "top"
                    }}
                    inputStyle={{width: 280}}
        />
    </div>
);

export const RecorderForm = (props) => {
    return (
        <form onSubmit={(e) => { e.preventDefault(); return false; }}>
        <div style={Object.assign({minWidth: 1010}, MAIN_SECTION)}>
                <div style={{display: "inline-block", width: 670, borderRight: "1px solid #ddd"}}>
                    <Header>What are you recommending?</Header>
                    <div style={{height: 750, overflow: "auto"}}>
                        <Recommendations {...props} />
                    </div>
                </div>
                <div style={{display: "inline-block", verticalAlign: "top"}}>
                    <Header>How did/will you communicate the recommendation?</Header>
                    <div style={{width: 384, padding: "15px 10px"}}
                         className="pure-form pure-form-aligned" >

                        <CommunicatedVia2 {...props.fields.communicatedVia}
                                          style={{marginBottom: 10}}
                                          labelStyle={{width: "5em"}} />

                        <DisseminatedOn {...props.fields.disseminatedOn}
                                        style={{marginBottom: 10}}
                                        labelStyle={{width: "5em"}}
                                        className={classNameForValidationErrors(props.fields.disseminatedOn)} />

                        <ToWhom {...props.fields.clients}
                                labelStyle={{width: "5em", marginTop: 5}}
                                contactGroups={props.contactGroups} />

                        <div style={{
                            width: "260px",
                            marginLeft: "6em",
                            color: LIGHT_TEXT_COLOR
                        }}>Disclosures will only be accessible by people you add to this box.</div>
                        <ContactGroups {...props.fields.contactGroups}
                                       groups={props.contactGroups}
                                       authorId={props.authorId} />
                    </div>
                </div>
                <div style={{
                    clear: "both",
                    padding: 10,
                    backgroundColor: "#eee",
                    textAlign: "right",
                    borderTop: "1px solid #ddd"
                }}>
                    <label>
                        <input type="checkbox"  {...props.fields.sendEmail}/>
                        &nbsp;Send disclosures to clients automatically&nbsp;
                    </label>
                    <button type="button"
                            className="pure-button pure-button-primary"
                            disabled={props.submitting}
                            onClick={props.handleSubmit(submitThenResetForm.bind(undefined, props))} >
                        { props.submitting ?
                            "Sending..." :
                            props.fields.sendEmail.value ?
                                "Send Disclosures" :
                                "Get Disclosures" }
                    </button>
                </div>
        </div>
        </form>
    );
};
RecorderForm.propTypes = {
    clients: React.PropTypes.arrayOf(React.PropTypes.string),
    communicatedVia: React.PropTypes.string,
    disseminatedOn: USER_ENTERED_DATE_TIME_PROP_TYPES,
    onCommunicationChange: React.PropTypes.func
};

function submitThenResetForm(props, values, dispatch) {
    return submitDissemination(values, dispatch).then(props.resetForm);
}

const mapStateToProps = (state) => ({
    authorId: state.authentication.authenticatedUser ? state.authentication.authenticatedUser.userId : "unknown",
    contactGroups: state.recorder.contactGroups
});

export default reduxForm({
    initialValues: {
        clients: [],
        contactGroups: [],
        disseminatedOn: null,
        recommendations: [ recommendationInitialValues() ],
        communicatedVia: COMMUNICATED_VIA.PHONE,
        sendEmail: true
    },
    form: "recorder",
    fields: [
        "clients",
        "contactGroups",
        "communicatedVia",
        "disseminatedOn",
        "recommendations[].searchUniverse",
        "recommendations[].legs[].direction",
        "recommendations[].legs[].instrument",
        "recommendations[].legs[].derivativeDescription",
        "recommendations[].legs[].suppliedPrice",
        "recommendations[].legs[].targetPrice",
        "recommendations[].producedOn",
        "recommendations[].validityPeriod",
        "recommendations[].reasoning",
        "recommendations[].hasConflictOfInterest",
        "recommendations[].conflictOfInterestDescription",
        "sendEmail"
    ],
    validate: validateRecorderForm
}, mapStateToProps)(RecorderForm);



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/RecorderForm.js
 **/